
/**
 * Script for All
 *
 * @author Space-Time Inc.
 */

/**
 * Back To Top (JS)
 *
 * @author Space-Time Inc.
 * @version 2020-02-19
 */

(function () {
	const OFFSET_Y = 0;

	const btn = document.getElementById('back-to-top');
	const ph = document.getElementsByClassName('site-footer-misc')[0];
	if (btn === null || ph === null) return;

	window.ST.onScroll(onScroll);
	window.ST.onResize(onScroll);
	if ('ontouchstart' in window) window.addEventListener('touchmove', onScroll);
	setTimeout(onScroll, 100);

	function onScroll() {
		// const btnR = btn.getBoundingClientRect();
		// const btnH = (btnR.bottom - btnR.top);

		const viewBottomY = window.innerHeight + OFFSET_Y;
		const footerTopY  = ph.getBoundingClientRect().top;

		if (viewBottomY > footerTopY) {
			btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
			btn.classList.remove('fixed');
		} else {
			btn.style.transform = '';
			btn.classList.add('fixed');
		}

		if (window.pageYOffset > window.innerHeight / 3) {
			btn.classList.remove('hidden');
		} else {
			btn.classList.add('hidden');
		}
	}
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2020-03-12
 */

document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile .button');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		return next.classList.contains('frame');
	}

	function setEventListener(btn) {
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		next.style.display = 'none';
		next.classList.add('hidden');
		setTimeout(() => { next.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		if (visible) {
			next.classList.remove('hidden');
		} else {
			next.classList.add('hidden');
		}
	}


	// -------------------------------------------------------------------------


	initToggleFor();
	window.initToggleFor   = initToggleFor;
	window.recalcMaxHeight = recalcMaxHeight;

	function initToggleFor() {
		const tfs = document.querySelectorAll('*[data-toggle-for]');

		for (let i = 0; i < tfs.length; i += 1) {
			const self = tfs[i];
			self.addEventListener('click', (e) => {
				if (e.defaultPrevented || e.target.closest('a')) return;
				e.preventDefault();
				if (self.dataset['toggleGroup']) {
					clearAll(tfs, self, self.dataset['toggleGroup']);
				}
				const id = self.dataset['toggleFor'];
				const tar = document.getElementById(id);
				if (!tar) return;
				tar.classList.toggle('hidden');
				if (tar.classList.contains('hidden')) {
					self.classList.remove('open');
				} else {
					self.classList.add('open');
				}
				if (self.classList.contains('jump-here')) ST.jumpToElement(self, 200);
			});
		}
	}

	function clearAll(tfs, cur, group) {
		for (let i = 0; i < tfs.length; i += 1) {
			const self = tfs[i];
			if (tfs[i].dataset['toggleGroup'] !== group) continue;
			if (cur === self) continue;
			self.classList.remove('open');
			const id = self.dataset['toggleFor'];
			const tar = document.getElementById(id);
			tar.classList.add('hidden');
		}
	}

	function recalcMaxHeight() {
		const wmhs = document.querySelectorAll('.wrapper-max-height');
		for (let i = 0; i < wmhs.length; i += 1) {
			const self = wmhs[i];
			self.style.maxHeight = null;
		}
		setTimeout(() => {
			for (let i = 0; i < wmhs.length; i += 1) {
				const self = wmhs[i];
				const inner = self.firstElementChild;
				const bcr = inner.getBoundingClientRect();
				const h = bcr.bottom - bcr.top;
				self.style.maxHeight = h + 'px';
			}
		}, 100);
		setTimeout(() => {
			for (let i = 0; i < wmhs.length; i += 1) {
				const self = wmhs[i];
				self.style.maxHeight = null;
			}
		}, 200);
	}

	ST.onResize(recalcMaxHeight, true);

});

/**
 * Global Nav (JS)
 *
 * @author Space-Time Inc.
 * @version 2024-08-28
 */

(function () {

	const CLS_CURRENT       = 'current';
	const CLS_MENU_ANCESTOR = 'menu-ancestor';
	const CLS_PAGE_ANCESTOR = 'page-ancestor';

	const SEL_NAV            = '.site-global-nav';
	const SEL_NAV_BAR_WRAP   = '.site-global-nav-bar-wrapper';
	const SEL_NAV_BAR        = '.site-global-nav-bar';
	const SEL_NAV_PANEL_WRAP = '.site-global-nav-panel-wrapper';

	const CLS_OPENED  = 'opened';
	const CLS_TOUCHED = 'touched';

	const PX_OFFSET_SCROLL = 20;

	let panels;

	document.addEventListener('DOMContentLoaded', function () {
		const rootBarMenu = document.querySelector(SEL_NAV + ' .menu');
		const subBarWrap  = document.querySelector(SEL_NAV_BAR_WRAP);
		panels = subBarWrap.querySelectorAll(':scope > div');


		// ---------------------------------------------------------------------


		const sh = document.querySelector('.site-header');
		const isFrontPage = !sh.classList.contains('global-nav-bar-visible');

		const items = document.querySelectorAll(SEL_NAV_BAR_WRAP + ' label[for]');
		const panelWrap = document.querySelector(SEL_NAV_PANEL_WRAP);
		const gnBar = new GlobalNav({ menuItems: items, wrapper: panelWrap, autoClose: true, onBeforeOpen: onBeforeOpen });

		const rootItems = document.querySelectorAll(SEL_NAV + ' label');
		const defRootItem = document.querySelector(SEL_NAV + ' .menu-ancestor label');
		new GlobalNav({ menuItems: rootItems, defaultMenuItem: defRootItem, wrapper: subBarWrap, autoClose: isFrontPage, groupingSuffix: '-root', childNav: gnBar });

		scrollMenu(SEL_NAV_BAR, PX_OFFSET_SCROLL);

		initCurrentBar(rootBarMenu, subBarWrap);
	});

	function scrollMenu(selBar, scrollOffset) {
		const mis = document.querySelectorAll(selBar + ' .menu > li');

		for (let i = 0; i < mis.length; i += 1) {
			if (mis[i].classList.contains(CLS_CURRENT) ||
				mis[i].classList.contains(CLS_MENU_ANCESTOR) ||
				mis[i].classList.contains(CLS_PAGE_ANCESTOR))
			{
				doScroll(mis[i]);
			}
			mis[i].firstChild.addEventListener('click', () => { doScroll(mis[i]); });
		}
		function doScroll(curMi) {
			let m = curMi.parentElement;
			while (!m.classList.contains('scroll')) m = m.parentElement;
			if (!m) return;

			const right = curMi.offsetLeft + curMi.offsetWidth;
			if (m.offsetWidth < right) m.scrollLeft = curMi.offsetLeft - scrollOffset;
			if (curMi.offsetLeft < m.scrollLeft) m.scrollLeft = curMi.offsetLeft - scrollOffset;
		}
	}

	function initCurrentBar(rootBarMenu, subBarWrap) {
		const raw = sessionStorage.getItem('current-global-nav-bar');
		const idx = raw ? parseInt(raw, 10) : 0;

		const mas = rootBarMenu.querySelectorAll('.menu-ancestor, .current');
		console.log('initCurrentBar', idx, mas.length);
		if (mas.length !== 1) {
			const gs = rootBarMenu.querySelectorAll('.group');
			gs[idx].classList.add('opened');

			setTimeout(() => {
				for (const p of panels) {
					p.classList.remove(CLS_OPENED);
					p.classList.remove(CLS_CURRENT);

					p.previousElementSibling.checked = false;
				}
				panels[idx].classList.add(CLS_OPENED);
				panels[idx].classList.add(CLS_CURRENT);

				panels[idx].previousElementSibling.checked = true;
			}, 100);  // Delay for Firefox
		} else {
			sessionStorage.removeItem('current-global-nav-bar');
		}
		setTimeout(() => subBarWrap.classList.add('visible'), 200);
	}

	function setCurrentBar() {
		let idx = -1;
		for (let i = 0; i < panels.length; ++i){
			if (panels[i].classList.contains('opened')) {
				idx = i;
				break;
			}
		}
		if (idx !== -1) {
			console.log('setCurrentBar', idx);
			sessionStorage.setItem('current-global-nav-bar', `${idx}`);
		}
	}


	// -------------------------------------------------------------------------


	function onBeforeOpen(item, panel) {
		if (!panel) return;
		const menu = panel.getElementsByClassName('menu')[0];
		if (!menu) return;

		const w = window.innerWidth;
		if (w <= 600) {
			menu.style.left = '';
			menu.style.right = '';
			menu.style.minWidth = '';
			return;
		}
		const bcrI = item.getBoundingClientRect();
		const bcrP = menu.getBoundingClientRect();
		const bcrPP = menu.parentElement.getBoundingClientRect();
		const wP = bcrP.right - bcrP.left;
		const wPP = bcrPP.right - bcrPP.left;
		const l = bcrI.left - bcrPP.left;

		if (wPP < l + wP) {
			menu.style.left = '';
			menu.style.right = '0px';
		} else {
			menu.style.left = l + 'px';
			menu.style.right = '';
		}
		menu.style.minWidth = (bcrI.right - bcrI.left) + 'px';
	}


	// -------------------------------------------------------------------------


	class GlobalNav {

		constructor(opts) {
			this._openItem  = null;
			this._openTime  = 0;
			this._scrollTop = 0;
			this._st        = null;

			this._isFirefox = window.ST.BROWSER === 'firefox';

			const menuItems      = opts['menuItems']       ? opts['menuItems']       : null;
			this._defMenuItem    = opts['defaultMenuItem'] ? opts['defaultMenuItem'] : null;
			this._wrap           = opts['wrapper']         ? opts['wrapper']         : null;
			const autoClose      = opts['autoClose']       ? opts['autoClose']       : false;
			const groupingSuffix = opts['groupingSuffix']  ? opts['groupingSuffix']  : '';
			this._child          = opts['childNav']        ? opts['childNav']        : null;
			this._onBeforeOpen   = opts['onBeforeOpen']    ? opts['onBeforeOpen']    : null;

			this._panels = this._wrap ? Array.prototype.slice.call(this._wrap.children) : [];
			this._dummy  = this._wrap ? this.initPanelRadios(this._panels, groupingSuffix) : null;

			this.addClickStateEventListener(menuItems);
			if (this._defMenuItem) this.open(this._defMenuItem);

			if (autoClose) {
				window.ST.onScroll(() => { this.onScroll(); });
				if (this._wrap) this._wrap.addEventListener('click', e => e.stopPropagation());
				document.addEventListener('click', () => { this.closeAll(); });
			}
		}

		initPanelRadios(panels, groupingSuffix) {
			let dummy = null;
			for (let i = 0; i < panels.length; i += 1) {
				const p = panels[i];
				if (i === 0) {
					dummy = this.createRadio('panel-dummy-ctrl', groupingSuffix);
					this._wrap.insertBefore(dummy, p);
				}
				const id = p.id;
				this._wrap.insertBefore(this.createRadio(id + '-ctrl', groupingSuffix), p);
			}
			if (dummy === null) {
				dummy = this.createRadio('panel-dummy-ctrl', groupingSuffix);
				this._wrap.insertBefore(dummy, null);
			}
			return dummy;
		}

		createRadio(id, groupingSuffix) {
			const e = document.createElement('input');
			e.id   = id;
			e.type = 'radio';
			e.name = 'panel-radios' + groupingSuffix;  // Must set the same name
			return e;
		}

		addClickStateEventListener(items) {
			if ('ontouchstart' in window) {
				for (let i = 0; i < items.length; i += 1) {
					items[i].addEventListener('click', this.createEventListenerTouch(items[i]));
					items[i].addEventListener('touchstart', () => {  // for avoiding hover style
						items[i].classList.add(CLS_TOUCHED);
						items[i].parentElement.classList.add(CLS_TOUCHED);
					});
				}
			} else {
				for (let i = 0; i < items.length; i += 1) {
					items[i].addEventListener('mouseenter', this.createEventListenerEnter(items[i]));
					items[i].addEventListener('mouseleave', this.createEventListenerLeave());
					items[i].addEventListener('click',      this.createEventListenerClick(items[i]));
				}
				for (let i = 0; i < this._panels.length; i += 1) {
					this._panels[i].addEventListener('mouseenter', () => {
						if (this._st) clearTimeout(this._st);
						this._st = null;
					});
				}
			}
		}


		// ---------------------------------------------------------------------


		closeAll() {
			if (this._defMenuItem) {
				this.open(this._defMenuItem);
				return;
			}
			this.clearStateOpened();
			if (this._dummy) this._dummy.click();
			if (this._st) clearTimeout(this._st);
			this._st = null;
		}

		open(item, clickAgain = false) {
			this.clearStateOpened();
			item.click();
			item.parentElement.classList.add(CLS_OPENED);
			setCurrentBar();

			setTimeout(() => {
				if (this._isFirefox && clickAgain) item.click();  // Click again for Firefox
				const p = this.itemToPanel(item);
				if (p) p.classList.add(CLS_OPENED);
				if (this._onBeforeOpen) this._onBeforeOpen(item, p);
			}, this._isFirefox ? 20 : 0);  // Delay time 20ms is for Firefox
			this._openItem = item;
			this._openTime = new Date().getTime();
			this._scrollTop = window.pageYOffset;
			this._st = null;
		}

		clearStateOpened() {
			if (this._child) this._child.closeAll();
			if (!this._openItem) return;
			this._openItem.parentElement.classList.remove(CLS_OPENED);
			const item = this._openItem;
			setTimeout(() => {
				if (item === this._openItem) return;
				const p = this.itemToPanel(item);
				if (p) p.classList.remove(CLS_OPENED);
			}, 400);
			this._openItem = null;
		}

		itemToPanel(item) {
			const tarId = item.getAttribute('for');
			if (tarId) {
				const radio = document.getElementById(tarId);
				if (radio) return radio.nextElementSibling;
			}
			return null;
		}

		onScroll() {
			if (this._child && this._child._openItem) return;
			if (this._openItem) {
				const openPanel = this._wrap.querySelector("input[type='radio']:checked + *");
				if (!openPanel) return;
				let bcr = openPanel.getBoundingClientRect();
				if (bcr.top === bcr.bottom) {
					const opc = openPanel.children[0];
					if (!opc) return;
					bcr = opc.getBoundingClientRect();
				}
				if (
					bcr.bottom < 0 ||  // When not fixed
					(0 < bcr.top && bcr.bottom < Math.abs(window.pageYOffset - this._scrollTop))  // When fixed
				) {
					this.closeAll();
				}
			}
		}


		// ---------------------------------------------------------------------


		createEventListenerTouch(item) {
			return (e) => {
				e.stopPropagation();
				if (item === this._openItem) {
					e.preventDefault();
					this.closeAll();
				} else {
					this.open(item);
				}
			};
		}


		// ---------------------------------------------------------------------


		createEventListenerEnter(item) {
			return (e) => {
				if (item === this._openItem) {
					e.preventDefault();
				} else {
					if (this._st) clearTimeout(this._st);
					this._st = setTimeout(() => {
						this.open(item);
					}, this._openItem !== null ? 400 : 200);
				}
			};
		}

		createEventListenerLeave() {
			return (e) => {
				if (this._st) clearTimeout(this._st);
				this._st = setTimeout(() => { this.closeAll() }, 800);
			};
		}

		createEventListenerClick(item) {
			return (e) => {
				e.stopPropagation();
				if (this._st) clearTimeout(this._st);
				const t = new Date().getTime();
				if (t - this._openTime < 200) return;
				if (item === this._openItem) {
					e.preventDefault();
					this.closeAll();
				} else {
					this.open(item, true);
				}
			};
		}

	}

})();

/**
 * Image Wrapper
 *
 * @author Space-Time Inc.
 * @version 2020-02-26
 */

document.addEventListener('DOMContentLoaded', () => {

	const ibos = document.querySelectorAll('a[data-stile~="image-box-opener"]');

	for (let i = 0; i < ibos.length; i += 1) {
		insertImageWrapper(ibos[i]);
	}

	function insertImageWrapper(a) {
		const img = a.querySelector('img');
		if (!img) return;
		const w = document.createElement('span');
		w.appendChild(img);
		a.appendChild(w);
	}

});

/* eslint-disable no-underscore-dangle */
/**
 * Modal Box (JS)
 *
 * @author Space-Time Inc.
 * @version 2020-03-30
 */

window.ST = window['ST'] || {};

(function (NS) {

	const SEL_TARGET_MODAL_BOX = '[data-stile ~= "modal-box"]';
	const ST_MODAL_BOX         = 'modal-box';
	const ST_MODAL_BOX_CLOSE   = 'modal-box-close';
	const ST_STATE_VISIBLE     = 'visible';

	NS.modifyModalBoxStyle = modifyModalBoxStyle;
	NS.modifyIframeStyle   = modifyIframeStyle;


	NS.addInit(2, () => {
		const objs = {}, list = [];
		const as1 = document.querySelectorAll(SEL_TARGET_MODAL_BOX);
		modifyModalBoxStyle(as1, objs, list);
	});

	function modifyModalBoxStyle(ts, objs, list) {
		for (let i = 0; i < ts.length; i += 1) {
			const t = ts[i];
			const id = t.dataset['id'] ? t.dataset['id'] : t.id;
			const mb = new ModalBox(t);
			objs[id] = mb;
			list.push(mb);
		}
		const mo = new MutationObserver((ms) => {
			for (let i = 0; i < ms.length; i += 1) {
				for (let j = 0; j < ts.length; j += 1) {
					if (ms[i].target === ts[j] && ts[j].classList.contains(ST_STATE_VISIBLE)) {
						const t = ts[j];
						const id = t.dataset['id'] ? t.dataset['id'] : t.id;
						objs[id].onOpen();
					}
				}
			}
		});
		const opts = { attributes: true, childList: false, characterData: false, attributeFilter: ['class'] };
		for (let i = 0; i < ts.length; i += 1) { mo.observe(ts[i], opts); }
		NS.onResize(() => {
			for (let i = 0; i < list.length; i += 1) list[i].onResize();
		}, true);
	}

	function preventWindowTouchMove(f) {
		let isTouching = false;
		window.addEventListener('touchmove', (e) => {
			if (!isTouching) return;
			if (e.target !== f) return;
			e.preventDefault();
			e.stopImmediatePropagation();
		}, { passive: false });
		f.addEventListener('touchstart', () => { isTouching = true; });
		f.addEventListener('touchend', () => { isTouching = false; });
	}


	// -------------------------------------------------------------------------


	function modifyIframeStyle(fs) {
		for (let i = 0; i < fs.length; i += 1) {
			const f = fs[i];
			const size = extractIframeSize(f);
			if (size) addIframeWrapper(f, size[0], size[1]);
		}
	}

	function extractIframeSize(f) {
		let w = parseInt(f.width);
		let h = parseInt(f.height);
		if (w && h) return [w, h];

		const sW = f.style.width;
		const sH = f.style.height;
		if (sW.indexOf('px') !== sW.length - 2) return null;
		if (sH.indexOf('px') !== sH.length - 2) return null;
		w = parseInt(sW);
		h = parseInt(sH);
		if (w && h) return [w, h];
		return null;
	}

	function addIframeWrapper(f, w, h) {
		const wrap = document.createElement('SPAN');
		NS.addStile(wrap, 'iframe-wrapper');
		const spacer = document.createElement('DIV');
		spacer.style.paddingTop = (100 * h / w) + '%';
		wrap.appendChild(spacer);
		wrap.style.maxWidth = w + 'px';
		f.parentElement.insertBefore(wrap, f);
		wrap.appendChild(f);
		wrap.dataset['aspect'] = Math.round(w / h * 1000) / 1000;
	}


	// -------------------------------------------------------------------------


	class ModalBox {

		constructor(frm) {
			this._frm = frm;
			this._child = frm.querySelector('*[data-aspect]');
			NS.addStile(this._frm, ST_MODAL_BOX);
			this._frm.addEventListener('click', (e) => { this.onClose(e); });
			if (this._frm.firstChild) this._frm.firstChild.addEventListener('click', (e) => { e.stopImmediatePropagation(); });

			const btn = document.createElement('span');
			NS.addStile(btn, ST_MODAL_BOX_CLOSE);
			this._frm.appendChild(btn);

			preventWindowTouchMove(this._frm);
			this._frm.addEventListener('wheel', (e) => {
				e.stopPropagation();
				e.preventDefault();
			});
			this._isOpened = false;
		}

		onOpen() {
			// console.log(this._frm);
			this._isOpened = true;
			this.onResize();
			this._frm.style.opacity = 1;
		}

		onResize() {
			if (this._isOpened && this._child) {
				const r = this._frm.getBoundingClientRect();
				const w = r.right - r.left;
				const h = r.bottom - r.top;
				const fw = (h * parseFloat(this._child.dataset.aspect));
				this._child.style.width = (w < fw) ? '' : (fw + 'px');
			}
		}

		onClose(e) {
			e.preventDefault();
			this._isOpened = false;
			this._frm.style.opacity = null;
			setTimeout(() => {
				NS.removeStile(this._frm, ST_STATE_VISIBLE);
				this._frm.classList.remove(ST_STATE_VISIBLE);
				if (this._child) this._child.style.width = null;

				this.pauseYouTube();
			}, 250);
		}

		pauseYouTube() {
			const iframe = this._frm.querySelector('iframe');
			if (iframe && iframe.src.startsWith('https://www.youtube.com')) {
				iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}

	}

})(window.ST);

/**
 * Scroll Shadow (JS)
 *
 * @author Space-Time Inc.
 * @version 2020-03-29
 */

(function () {

	const SEL_CONTAINER = '.scroll-shadow';
	const CLS_SHADOW    = 'shadow';


	document.addEventListener('DOMContentLoaded', () => {
		const cs = document.querySelectorAll(SEL_CONTAINER);
		const ss = [];
		const ps = [];
		for (let i = 0; i < cs.length; i += 1) {
			const c = cs[i];
			const s = createShadow(c);
			c.addEventListener('scroll', ST.throttle(() => { updateShadow(c, s); }));
			ST.onResize(() => { updateShadow(c, s); }, true);
			ss.push(s);
			ps.push(c.parentElement.parentElement);
		}
		const mo = new MutationObserver((ms) => {
			for (let i = 0; i < cs.length; i += 1) updateShadow(cs[i], ss[i]);
		});
		const opts = { attributes: true, childList: false, characterData: false, attributeFilter: ['class'] };
		for (let i = 0; i < ps.length; i += 1) { mo.observe(ps[i], opts); }
	});


	// -------------------------------------------------------------------------


	function createShadow(cont) {
		const shadow = document.createElement('div');
		shadow.className           = CLS_SHADOW;
		shadow.style.position      = 'absolute';
		shadow.style.top           = '0';
		shadow.style.left          = '0';
		shadow.style.width         = '100%';
		shadow.style.height        = '100%';
		shadow.style.pointerEvents = 'none';

		cont.parentElement.style.position = 'relative';
		cont.parentElement.appendChild(shadow);
		return shadow;
	}

	function updateShadow(cont, shadow) {
		if (isScrollable(cont)) {
			shadow.style.background = calcShadowStyle(cont);
		} else {
			shadow.style.background = '';  // This must be '' for IE11
		}
	}

	function isScrollable(cont) {
		return (cont.scrollWidth - cont.clientWidth > 2);  // for avoiding needless scrolling
	}

	function calcShadowStyle(cont) {
		const r = cont.scrollLeft / (cont.scrollWidth - cont.clientWidth);
		let rl = 0.35, rr = 0.35;
		if (r < 0.1) rl *= r / 0.1;
		if (0.9 < r) rr *= (1 - r) / 0.1;
		const sl = `linear-gradient(to right, rgba(0,0,0,${rl}), rgba(0,0,0,0)) left top`;
		const sr = `linear-gradient(to left,  rgba(0,0,0,${rr}), rgba(0,0,0,0)) right top`;
		const size = ' / 1.5rem 100% no-repeat scroll';
		return sl + size + ',' + sr + size;
	}

})();

/**
 * Search Panel
 *
 * @author Space-Time Inc.
 */

document.addEventListener('DOMContentLoaded', () => {
	const searchPanel = document.querySelector('.part-search-panel');
	if (!searchPanel) {
		return;
	}


	// -------------------------------------------------------------------------


	const search = document.querySelector('.site-global-nav-search:not(.small)');
	search.addEventListener('click', () => {searchPanel.classList.toggle('opened');});

	const smallSearch = document.querySelector('.site-global-nav-search.small');
	if (smallSearch) smallSearch.addEventListener('click', () => {searchPanel.classList.toggle('opened');});


	// -------------------------------------------------------------------------


	const searchForms = document.querySelectorAll('form[role="search"]');
	for (const sf of searchForms) {
		const inputField  = sf.querySelector('.field');
		const inputSubmit = sf.querySelector('.submit');

		inputSubmit.addEventListener('click', () => {
			const k = inputField.value.trim();
			if (k) storedKeywords = addKeyword(storedKeywords, k);
		});
	}

	const inputField  = searchPanel.querySelector('.field');
	const inputSubmit = searchPanel.querySelector('.submit');


	// -------------------------------------------------------------------------


	let storedKeywords = initKeyword();

	const localKeywords = searchPanel.querySelector('.list-item-keyword.local');

	for (const [t, k] of storedKeywords) {
		const bd = document.createElement('button');
		bd.classList.add('delete');
		const bs = document.createElement('button');
		bs.classList.add('search');
		bs.innerText = k;
		const ba = document.createElement('button');
		ba.classList.add('add');

		const li = document.createElement('li');
		li.classList.add('item-keyword');
		li.appendChild(bd);
		li.appendChild(bs);
		li.appendChild(ba);

		localKeywords.appendChild(li);
	}

	const ss = searchPanel.querySelectorAll('.list-item-keyword.common .item-keyword .search');
	const commonKeywords = new Set(Array.from(ss).map(e => e.innerText));


	// -------------------------------------------------------------------------


	const ks = searchPanel.querySelectorAll('.item-keyword');

	for (const k of ks) {
		const del = k.querySelector('.delete');
		const add = k.querySelector('.add');
		const sea = k.querySelector('.search');

		if (del) del.addEventListener('click', () => onDeleteClick(k, sea));
		add.addEventListener('click', () => onAddClick(k, sea));
		sea.addEventListener('click', () => onSearchClick(k, sea));
	}

	function onDeleteClick(k, sea) {
		storedKeywords = deleteKeyword(storedKeywords, sea.innerText);
		k.parentElement.removeChild(k);
	}

	function onAddClick(k, sea) {
		inputField.value = sea.innerText;
	}

	function onSearchClick(k, sea) {
		inputField.value = sea.innerText;
		inputSubmit.click();
	}


	// -------------------------------------------------------------------------


	function initKeyword() {
		const raw = sessionStorage.getItem('search-keywords');
		if (raw) {
			const n = new Date().toISOString().slice(0, 10).replaceAll('-', '');

			let ks = JSON.parse(raw);
			ks = ks.filter(([t,]) => n - t < 7);
			return ks
		}
		return [];
	}

	function addKeyword(ks, k) {
		if (commonKeywords.has(k)) return;

		ks = ks.filter(([, l]) => l !== k);
		const t = new Date().toISOString().slice(0, 10).replaceAll('-', '');

		ks.unshift([t, k]);
		const raw = JSON.stringify(ks);
		sessionStorage.setItem('search-keywords', raw);

		return ks;
	}

	function deleteKeyword(ks, k) {
		ks = ks.filter(([, l]) => l !== k);

		const raw = JSON.stringify(ks);
		sessionStorage.setItem('search-keywords', raw);

		return ks;
	}

});


document.addEventListener('DOMContentLoaded', () => {
	const bs   = document.querySelectorAll('.site-global-nav .menu li.button');
	const list = document.querySelector('.site-global-nav-button.small .menu');

	for (const b of bs) {
		list.appendChild(b.cloneNode(true));
	}
});
